import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { SelectOption } from '../../../../types/ViewModel/SelectOption';
import { TankPlanCondition } from 'src/enums/stowage/tankPlanCondition';
import { useStowageStore } from 'src/context/StowageContext';
import { SelectWrapper } from './SelectTankPlanCondition.style';

const tankPlanConditionList = [
    new SelectOption(TankPlanCondition.OperationsInCall.toString(), 'Operations in call'),
    new SelectOption(TankPlanCondition.LoadingOperations.toString(), 'Loading cargoes'),
    new SelectOption(TankPlanCondition.TransitOperations.toString(), 'Cargoes in transit'),
    new SelectOption(TankPlanCondition.UnloadingOperations.toString(), 'Unloading cargoes'),
];

const SelectTankPlanConditionComponent: React.FC = () => {
    const { selectedTankPlanCondition, setSelectedTankPlanCondition } = useStowageStore();
    const [, setSelectedOptionCondition] = useState<SelectOption>(null);

    useEffect(() => {
        if (selectedTankPlanCondition === TankPlanCondition.Arrival) {
            setSelectedOptionCondition(null);
        } else if (selectedTankPlanCondition === TankPlanCondition.Departure) {
            setSelectedOptionCondition(null);
        }
    }, [selectedTankPlanCondition]);

    const onChange = (e: SelectOption) => {
        if (parseInt(e.value) === 0) {
            setSelectedTankPlanCondition(TankPlanCondition.Departure);
            setSelectedOptionCondition(null);
        } else {
            setSelectedTankPlanCondition(parseInt(e.value));
            setSelectedOptionCondition(null);
        }
    };

    const mapSelectedTankPlanCondition = (): SelectOption | null => {
        return tankPlanConditionList.find((o) => o.value === selectedTankPlanCondition?.toString());
    };

    const mappedOptions = (): SelectOption[] => {
        const vList: SelectOption[] = tankPlanConditionList.map((v) => {
            return new SelectOption(v.value, v.label);
        });
        return vList.sort((a, b) => a.label.localeCompare(b.label));
    };

    const styles = {
        control: (css) => ({ ...css, minHeight: '30px', height: '30px', width: '100%', lineHeight: '1' }),
        option: (styles) => {
            return {
                ...styles,
                display: 'block !important',
                padding: '5px 10px 5px 10px',
                height: '20px',
                lineHeight: '1',
            };
        },
    };

    return (
        <SelectWrapper>
            <Select
                className="select-container"
                value={mapSelectedTankPlanCondition()}
                options={mappedOptions()}
                onChange={onChange}
                isSearchable={true}
                styles={styles}
                placeholder="Select condition"
                classNamePrefix="tankplan_filter"
            />
        </SelectWrapper>
    );
};

export default SelectTankPlanConditionComponent;
